import * as React from 'react';
import { FC } from 'react';
import classnames from 'classnames';
import { useContext } from './useFormContext';

const SubmitButton: FC<{ isSubmitted: boolean; isValid: boolean }> = ({ isSubmitted, isValid }) => {
  const { locales } = useContext();

  return (
    <div className="rs-column-small-12 rs-text-align_center">
      <input
        type="submit"
        id="submit"
        value={isSubmitted ? locales.disable_with : locales.submit}
        disabled={!isValid || isSubmitted}
        className={classnames({ disabled: !isValid }, 'rs-button rs-button_primary')}
      />
    </div>
  );
};

export default SubmitButton;
